import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

// TS port of the source (Falah) app's pages/reports/procurement/ReceivingLogReport.jsx.
const STATUS_OPTIONS: ReportOption[] = [
  { value: 'partially_received', label: 'Partially Received' },
  { value: 'fully_received', label: 'Fully Received' },
  { value: 'issue_reported', label: 'Issue Reported' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'po_number', label: 'PO #' },
  { key: 'invoice_number', label: 'Invoice #' },
  { key: 'received_by', label: 'Received By' },
  { key: 'received_at', label: 'Date' },
  { key: 'quantity_received', label: 'Qty', align: 'right' },
  { key: 'condition', label: 'Condition' },
  { key: 'status', label: 'Status' },
  { key: 'remarks', label: 'Remarks' },
];

export function ReceivingLogReport() {
  return (
    <ReportView
      title="Goods Receiving Log"
      description="Goods receipts logged against purchase orders."
      endpoint="/reports/procurement/receiving-log"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
